export enum AUTH_PAGE_ENUM {
  LOGIN = "login",
  OTP_VERIFICATION = "otp_verification",
}

export enum AUTH_QUERY_ENUM {
  VERIFY_EMAIL_OTP = "VerifyEmailOtp",
}
